// extracted by mini-css-extract-plugin
module.exports = {"item":"drawer-filters_item__5TaRF","paddings":"drawer-filters_paddings__xx5BJ"};